import Service from './Service';

const BASE_URL = process.env.REACT_APP_AUTH_SERVER_BASE_URL ?? '';

class FileService extends Service {
  static upload(file: File, entityType: string, entityId?: string) {
    const form = new FormData();
    form.append('file', file);
    form.append('entity_type', entityType);
    if (entityId) form.append('entity_id', entityId);
    return this.Http.post<{ file_id: string; file_key: string; serve_url: string }>(
      '/files/upload',
      form
    ).then(this.getData);
  }

  /**
   * Absolute URL of the file route. It sits behind auth, so this is only usable
   * where an Authorization header can be sent (fetch, react-pdf httpHeaders) —
   * never as an <img src>. For images use `useAuthedImage`.
   */
  static getUrl(fileKey: string) {
    return `${BASE_URL}/files/${fileKey}`;
  }

  static delete(fileKey: string) {
    return this.Http.delete(`/files/${fileKey}`).then(this.getData);
  }

  /**
   * Sobrescreve o conteúdo mantendo a MESMA file_key — a URL pública não muda,
   * então referências no enunciado continuam válidas. Só PNG/JPEG.
   */
  static replace(fileKey: string, file: File) {
    const form = new FormData();
    form.append('file', file);
    return this.Http
      .put<{ file_key: string; serve_url: string }>(`/files/${fileKey}`, form)
      .then(this.getData);
  }

  /** Baixa o arquivo pela rota autenticada — serve chaves que a rota pública recusa. */
  static download(fileKey: string) {
    return this.Http
      .get<Blob>(`/files/${fileKey}`, { responseType: 'blob' })
      .then(this.getData);
  }
}

export default FileService;
